import { useAsyncFn } from 'react-use-v13';
import { useState } from 'react';
import API from '@scale/frontend-lib/dashboard-api';
import {
  IStellarGenAITask as StellarTask,
  GetStellarGenAITaskByAttemptParams,
  CreateStellarGenAITaskReqBody,
  UpdateStellarGenAITaskParams,
  UpdateStellarGenAITaskReqBody,
} from '@scale/shared/types/stellarGenAITask';

export const useStellarTask = () => {
  const [data, setData] = useState<StellarTask | null>(null);

  const [getState, executeGet] = useAsyncFn(async (params?: GetStellarGenAITaskByAttemptParams) => {
    if (!params) {
      return;
    }
    const resp = await API.genai.getStellarGenAITaskByAttempt(params);
    setData(resp.stellarTask);
  }, []);

  const [createState, executeCreate] = useAsyncFn(
    async (reqBody?: CreateStellarGenAITaskReqBody) => {
      if (!reqBody) {
        return;
      }
      const resp = await API.genai.createStellarGenAITask(reqBody);
      setData(resp.stellarTask);
    },
    [],
  );

  const [updateState, executeUpdate] = useAsyncFn(
    async (params?: UpdateStellarGenAITaskParams, reqBody?: UpdateStellarGenAITaskReqBody) => {
      if (!params || !reqBody) {
        return;
      }
      const resp = await API.genai.updateStellarGenAITask(params, reqBody);
      setData(resp.stellarTask);
    },
    [],
  );

  return {
    data,
    getState,
    executeGet,
    createState,
    executeCreate,
    updateState,
    executeUpdate,
  };
};
